import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";

import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import Deletepopup from "../../../components/Modal/Deletepopup";

// Updated custom hook paths
import apiCall from "../../../components/Api";
import Actions from "../../../components/Common/Actions";
import FilledButton from "../../../components/Common/Buttons/FilledButton";
import ListPageLayout from "../../../components/Layout";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";

const HealthArticleBlogSearch = () => {
  const navigate = useNavigate();
  const addNewKeyword = {
    id: "addnewpost",
    onClick: () => navigate("/blog-search-keyword-create"),
    style: { width: "240px" },
    label: "Add New Keyword",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);
  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Filter states

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}blog-search-keyword/list`,
      initialParams: {
        sort,
        searchText: search,
        // selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "blog-search-keyword",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const handleActive = async (id, status) => {
    try {
      await setLoader(true);
      await apiCall(`blog-search-keyword/update/active/${id}`, "PATCH", {
        active: !status,
      });

      fetchData();
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    { title: "Keyword", dataIndex: "keyword", key: "keyword", fixed: "left" },
    {
      title: "Status",
      width: 150,
      dataIndex: "active",
      key: "active",
      render: (active) => (active ? "Verified" : "Not Verified"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          recordActiveStatus={record.active}
          isEdit={true}
          isDelete={true}
          isActive={true}
          onClickEdit={() =>
            navigate(`/blog-search-keyword-edit/${record._id}`)
          }
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickActive={() => handleActive(record._id, record.active)}
        />
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const breadcrumbsList = useMemo(
    () => [
      { text: "Blogs", link: "/healtharticle" },
      { text: "Blog Search Keyword", link: "" },
    ],
    [],
  );

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs
          className="w-75 healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewKeyword} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default HealthArticleBlogSearch;
